import { Omrade } from '@/domain/omrader/Omrade';
import { WKTObject } from '@/domain/WKTObject';
import { WKT } from 'ol/format';
import { Feature } from 'ol';
import OLPolygon, { fromExtent } from 'ol/geom/Polygon';
import { Vegobjekt } from '@/domain/vegobjekter/Vegobjekt';

export class Polygon extends Omrade {
    static serializer = new WKT();
    declare readonly kartutsnitt: WKTObject;
    readonly wkt: WKTObject;
    constructor(feature: Feature | WKTObject) {
        if (feature instanceof Feature) {
            const featureGeometry = feature.getGeometry();
            if (!featureGeometry) {
                throw new Error('Cannot construct Polygon without geometry');
            }
            const geometry = new WKTObject(
                6173,
                Polygon.serializer.writeFeature(feature, { decimals: 3 })
            );
            super(
                'Polygon',
                Math.random(),
                new WKTObject(
                    6173,
                    Polygon.serializer.writeGeometry(
                        fromExtent(featureGeometry.getExtent()),
                        {
                            decimals: 3,
                        }
                    )
                ),
                null,
                Vegobjekt.dummy(0, 0, geometry)
            );
            this.wkt = geometry;
        } else if (feature instanceof WKTObject) {
            const geometry = Polygon.serializer.readGeometry(feature.wkt);
            super(
                'Polygon',
                0,
                new WKTObject(
                    6173,
                    Polygon.serializer.writeGeometry(fromExtent(geometry.getExtent()), {
                        decimals: 3,
                    })
                ),
                null,
                Vegobjekt.dummy(0, 0, feature)
            );
            this.wkt = feature;
        } else {
            throw new Error('Invalid type for constructing Polygon');
        }
    }

    override(modifyObject: { [P in keyof Polygon]?: Polygon[P] }): Polygon {
        return Object.assign(Object.create(Polygon.prototype), {
            ...this,
            ...modifyObject,
        });
    }

    withVisible(visible: boolean): Polygon {
        return this.override({ visible });
    }

    getAreaType(): string {
        return 'Polygonfilter';
    }

    toParams(): string {
        const geometry = Polygon.serializer.readGeometry(this.wkt.wkt);
        if (!(geometry instanceof OLPolygon)) {
            throw new Error('WKT is not a POLYGON');
        }
        if (geometry.getLinearRingCount() !== 1) {
            throw new Error('Polygoner med hull støttes ikke');
        }
        return geometry
            .getCoordinates()[0]
            .map(coordinate => coordinate.join(' '))
            .join(', ');
    }

    toString(): string {
        return 'Polygon';
    }
}
